import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getClaims, getPreAuthTableData } from '../../action';
import "../../styles/theme.scss"
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Paper, IconButton, Input, Button, Box } from '@mui/material';
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import TableN from "../../reusableComponents/components/generics/TableN"
import { clearClaimResp } from '../../store/actions/exampleAction';
import { ArrowDropDownIcon } from '@mui/x-date-pickers/icons';
import ArrowBack from '@mui/icons-material/ArrowBack';
import Logout from '@mui/icons-material/Logout';
import { Pre_Autharization_Form } from '../../utils/constant';
const StyledPaper = styled(Paper)(({ theme }) => ({
    ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
    ...theme.paper.header,
    fontSize: 600,
    padding: ".8rem",
}));
function PreAuthTable() {
    const SignInSuccess = useSelector((state) => state);
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [policyHolderData, setPolicyHolderData] = useState();
    const [preAuthData, setPreAuthData] = useState();

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageInfo, setPageInfo] = useState();
    const [endCursors, setEndCursors] = useState();
    const token = localStorage.getItem("token");
    const [startCursors, setStartCursors] = useState();
    const userData = useSelector((state) => state.profileReducer);
    const userId = SignInSuccess?.profileReducer?.currentUserResponseData?.id;
    const adminData = SignInSuccess?.fosaReducer?.AdminIdData;
    let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]

    useEffect(() => {
        dispatch(clearClaimResp())
        dispatch(getPreAuthTableData([]))
    }, [])

    console.log(preAuthData, 'PreAuthData');


    useEffect(() => {
        if (healthData?.location?.parent?.uuid &&
            healthData?.location?.uuid &&
            healthData?.uuid) {
            let params = buildQueryParams({
                // filters: filter,
                filters: {},
                pageSize,
                beforeCursor: endCursors,
                afterCursor: startCursors,
                // healthFacility_Location_Parent_Uuid: healthData?.location?.parent?.uuid,
                // healthFacility_Location_Uuid: healthData?.location?.uuid,
                healthFacility_Uuid: healthData?.uuid,
            });
            if (healthData?.location?.parent?.uuid ||
                healthData?.location?.uuid ||
                healthData?.uuid) {
                dispatch(getPreAuthTableData(params));
            }
        }
    }, [healthData, healthData?.location?.parent?.uuid, healthData?.location?.uuid, healthData?.uuid, page, pageSize]);
    const buildQueryParams = (state) => {
        let params = [];

        // Ensure state.filters exists before trying to access its properties
        if (state.filters) {
            params = Object.keys(state.filters)
                .filter((f) => !!state.filters[f]["filter"])
                .map((f) => state.filters[f]["filter"]);
        }

        if (!state.beforeCursor && !state.afterCursor) {
            params.push(`first: ${state.pageSize}`);
        }
        if (!!state.afterCursor) {
            params.push(`after: "${state.afterCursor}"`);
            params.push(`first: ${state.pageSize}`);
        }
        if (!!state.beforeCursor) {
            params.push(`before: "${state.beforeCursor}"`);
            params.push(`last: ${state.pageSize}`);
        }
        if (!!state.orderBy) {
            params.push(`orderBy: ["${state.orderBy}"]`);
        }
        if (!!state.healthFacility_Location_Parent_Uuid) {
            params.push(`healthFacility_Location_Parent_Uuid: "${state.healthFacility_Location_Parent_Uuid}"`);
        }
        if (!!state.healthFacility_Location_Uuid) {
            params.push(`healthFacility_Location_Uuid: "${state.healthFacility_Location_Uuid}"`);
        }
        if (!!state.healthFacility_Uuid) {
            params.push(`healthFacility_Uuid: "${state.healthFacility_Uuid}"`);
        }

        return params;
    };

    useEffect(() => {
        if (SignInSuccess?.fosaReducer?.PreAuthData) {
            setPreAuthData(
                SignInSuccess?.fosaReducer?.PreAuthData
            );
            setPageInfo(
                SignInSuccess?.fosaReducer?.PreAuthDataPageInfo
                    .totalCount
            );
            setStartCursors(
                SignInSuccess?.fosaReducer?.PreAuthDataPageInfo
                    ?.endCursor
            );
            setEndCursors(
                SignInSuccess?.fosaReducer?.PreAuthDataPageInfo
                    ?.startCursor
            );
        }
    }, [SignInSuccess]);
    const statusMapping = {
        "-1": t("Rejected"),
        "1": t("Created"),
        "2": t("Waiting for Approval"),
        "3": t("Rework"),
        "4": t("Approved"),
    };
    const statusStyles = {
        "-1": { color: 'red' },
        "1": { color: 'blue' },
        "2": { color: 'gray' },
        "3": { color: 'orange' },
        "4": { color: 'green' }, 
    };
    const headers = () => {
        var h = [
            t("RequestNo"),
            t("Request Date"),
            t("InsureeCamuNo"),
            t("Insuree Name"),
            t("Action Taken By"),
            t("Status"),

        ];
        return h;
    };
    const itemFormatters = () => {
        var row = [
            (preAuthData) =>
                !!preAuthData.code
                    ? preAuthData.code
                    : "",
            (preAuthData) => {
                const dateValidFrom = new Date(preAuthData.dateCreated);
                return dateValidFrom.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false 
                });
            },
            (preAuthData) =>
                !!preAuthData.insuree
                    ? preAuthData.insuree?.camuNumber
                    : "",
            (preAuthData) =>
                !!preAuthData.insuree
                    ? preAuthData.insuree?.otherNames
                    : "",
            (preAuthData) =>
                        !!preAuthData.userCreated
                            ? preAuthData.userCreated?.username
                            : "",
            (policyHolderData) => {
                const statusValue = policyHolderData.status;
                const statusText = statusMapping[statusValue] || "Unknown Status";
                const statusStyle = statusStyles[statusValue] || {};
                const textFr = statusText === "Waiting for Approval" ? "En attente d’approbation" : statusText;
                return <span style={statusStyle}>{textFr}</span>;
            }
        ];

        return row;
    };
    const handleRowsPerPageChange = (newPageSize) => {
        setPageSize(newPageSize);
        setEndCursors(null);
        setStartCursors(null);
        setPage(0);
    };
    const handleNavigation = (direction) => {
        if (direction === 'forward') {
            setEndCursors(null);
        } else if (direction === 'backward') {
            setStartCursors(null);
        }
    };
    const handleRowDoubleClick = (rowData) => {
        console.log(rowData,'rowData');
        navigate(`/fosa/preautharizationForm/:id=${rowData.id}`);
    };

    const handleOpen = () => {

    };

    return (
        <Grid container>
            {/* <TableN/> */}
            <Grid item xs={12}>
                <StyledPaper>
                    <StyledPaperHeader
                        container
                        alignItems="center"
                        direction="row"
                    >

                        <Box item alignItems="center" style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                            <Typography variant="h6">{t("PreAuthorizationRequestslist")}</Typography>
                        </Box>

                    </StyledPaperHeader>
                    <TableN
                        headers={headers()}
                        itemFormatters={itemFormatters()}
                        items={preAuthData ? preAuthData : []}
                        withSelection={"single"}
                        withPagination={true}
                        rowsPerPageOptions={[10, 50, 100]}
                        defaultPageSize={5}
                        page={page}
                        pageSize={pageSize}
                        count={pageInfo}
                        onChangePage={(event, newPage) => {
                            setPage(newPage);
                            handleNavigation(newPage > page ? 'forward' : 'backward');
                        }}
                        onChangeRowsPerPage={handleRowsPerPageChange}
                        onDoubleClick={handleRowDoubleClick}
                    // rowLocked={this.rowLocked}
                    />
                </StyledPaper>
            </Grid>
        </Grid> 
    )
}

export default PreAuthTable